import Cookies from '../../helpers/cookie'
import { IdentityService } from '../../services'

const state = {
    is_authenticated: false,
    last_active_time: null,
    signed_in_time: null,
    stay_signed_in: false,
    claims: []
}

// getters
const getters = {
    authenticated: (state) => {
        return state.is_authenticated;
    },
    last_active_time: (state) => {
        return state.last_active_time;
    },
    signed_in_time: (state) => {
        return state.signed_in_time;
    },
    stay_signed_in: (state) => {
        return state.stay_signed_in;
    },
    claims: (state) => {
        return state.claims;
    }
}

// mutations
const mutations = {
    signout(state) {
        state.is_authenticated = false;
        state.signed_in_time = null;
        state.stay_signed_in = false;
    },
    signin(state, model) {
        state.is_authenticated = true;
        state.signed_in_time = new Date().toISOString();
        state.stay_signed_in = model.stay_signed_in;
    },
    set_last_active_time(state, value) {
        state.last_active_time = value;
    },
    set_claims(state, claims) {
        state.claims = claims;
    }
}

// actions
const actions = {
    refresh_last_active({ commit }) {
        commit('set_last_active_time', new Date().toISOString());
    },
    get_authenticated_until() {
        let cookieValue = Cookies.get('authenticated_until');
        return cookieValue ? cookieValue : null;
    },
    async signin({ commit }, model) {
        let identityService = new IdentityService();
        await identityService.signin(model)
        commit('signin', model);
        commit('set_last_active_time', new Date().toISOString());
        commit('set_last_active_time', new Date().toISOString());
        let claimsCookieValue = Cookies.get('claims');
        let claims = [];
        try {
            claims = JSON.parse(claimsCookieValue)
        }
        catch (ex) {
            console.log(ex)
        }
        commit('set_claims', claims ? claims : []);
    },
    async signout({ commit }) {
        let identityService = new IdentityService();
        await identityService.signout();
        commit('signout');
        commit('set_last_active_time', null);
        commit('set_claims', []);
    },

}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
